import { showSuccess, showError } from "@/lib/toastHelpers";
import { useQuery } from "@tanstack/react-query";
import { useApiMutation } from "@/hooks/useApiMutation";
import { apiRequest, queryClient } from "@/lib/queryClient";
import type { StarterEquipment } from "@/lib/types";

interface UseStarterEquipmentOptions {
  onCreateSuccess?: () => void;
  onUpdateSuccess?: () => void;
  onDeleteSuccess?: () => void;
}

export function useStarterEquipment(options?: UseStarterEquipmentOptions) {

  const { data: starterEquipment, isLoading } = useQuery<StarterEquipment[]>({
    queryKey: ["/api/starter-pack/equipment"],
  });

  const createEquipmentMutation = useApiMutation({
    endpoint: "/api/starter-pack/equipment",
    method: "POST",
    invalidate: [["/api/starter-pack/equipment"]],
    successMessage: "Starter equipment created",
    errorMessage: "Failed to create equipment",
    onSuccess: options?.onCreateSuccess,
  });

  const updateEquipmentMutation = useApiMutation({
    endpoint: (vars: { id: string }) => `/api/starter-pack/equipment/${vars.id}`,
    method: "PATCH",
    invalidate: [["/api/starter-pack/equipment"]],
    successMessage: "Starter equipment updated",
    errorMessage: "Failed to update equipment",
    onSuccess: options?.onUpdateSuccess,
  });

  const deleteEquipmentMutation = useApiMutation({
    endpoint: (vars: { id: string }) => `/api/starter-pack/equipment/${vars.id}`,
    method: "DELETE",
    invalidate: [["/api/starter-pack/equipment"]],
    successMessage: "Starter equipment deleted",
    errorMessage: "Failed to delete equipment",
    onSuccess: options?.onDeleteSuccess,
  });

  return {
    starterEquipment,
    isLoading,
    createEquipmentMutation,
    updateEquipmentMutation,
    deleteEquipmentMutation,
  };
}
